import { Link } from "react-router-dom"
import styled from "styled-components"

export const BannerOverlaySubtext = styled.p`
  color: white;
  font-family: roboto;
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.3rem;
  font-weight: 600;
  @media ${({ theme }) => theme.mediaQueries.mobile} {
    font-size: 0.6rem;
    width: auto;
  }

  @media ${({ theme }) => theme.mediaQueries.mobile_landscape} {
    // display: none;
  }

  @media ${({ theme }) => theme.mediaQueries.ipad_pro}{
    margin-top: 25%;
    font-size: 1.5rem;
  }

  @media ${({ theme }) => theme.mediaQueries.tablet}{
    font-size: 1.2rem;
    width: 100%;
    margin-bottom: 10%;

  }
`

export const BannerOverlayText = styled.h1`
  color: white;
  font-family: graphik;
  font-size: 3.5rem;
  letter-spacing: 0.1rem;
  font-weight: 700;
  // width: 40%;
  margin-top: 4rem;
  width: 75%;
  margin-top: 6rem;
  @media ${({ theme }) => theme.mediaQueries.mobile} {
    font-size: 1.3rem;
    width: 100%;
    margin-top: 3rem;
    line-height: 3rem;

  }

  @media ${({ theme }) => theme.mediaQueries.mobile_landscape} {
    // display: none;
    font-size: 1.3rem;
    width: auto;
    margin-top: 3rem;
    line-height: 3rem;

  }

  @media ${({ theme }) => theme.mediaQueries.ipad_pro}{
    width: 110%;
    font-size: 3.5rem;
    margin-top: 30%;
  }

  @media ${({ theme }) => theme.mediaQueries.tablet}{
    font-size: 2.8rem;
    width: 100%;
    margin-top: 3rem;

  }
  @media ${({ theme }) => theme.mediaQueries.tablet_landscap}{
    font-size: 3rem;
    width: 108%;
  }

`

export const BannerOverlayTextLink = styled(Link)`
  color: white;
  font-family: graphik;
  font-size: 3.5rem;
  letter-spacing: 0.1rem;
  font-weight: 700;
  width: 40%;
  margin-top: 4rem;
  text-decoration: none;
`

export const MenuTextLink = styled(Link)`
  color: white;
  font-family: roboto;
  font-size: 1.8rem;
  letter-spacing: 0.1rem;
  font-weight: 300;
  width: 100%;
  margin-top: 1.5rem;
  text-decoration: none;
  text-transform: capitalize;
`

export const BannerOverlayLink = styled(Link)`
  color: white;
  font-family: graphik;
  font-size: 3.5rem;
  letter-spacing: 0.1rem;
  font-weight: 700;
  width: 40%;
  margin-top: 4rem;
  text-decoration: none;
`

export const ActionLinks = styled.p`
  color: white;
  font-size: 0.8rem;
  font-family: "Roboto";
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 0.1rem;
`

export const ActionLinkTag = styled.a`
  color: white;
  font-size: 0.8rem;
  font-family: "Roboto";
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 0.1rem;
  text-decoration: none;
`

export const SubActionLink = styled.p`
  color: white;
  font-size: 0.8rem;
  font-family: "Roboto";
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 0.1rem;

  transition: all var(--speed);

  &:hover {
    color: var(--color-pri);
  }

  &:focus {
    color: var(--color-pri);
  }

  &:active {
    color: var(--color-pri);
  }
`

export const MenuStyledLink = styled.p`
  color: white;
  font-size: 0.75rem;
  font-family: "Roboto";
  text-transform: uppercase;
  font-weight: 400;
  letter-spacing: 0.1rem;
  transition: all var(--speed);
  padding: 0.7rem;

  &:hover {
    color: var(--color-pri);
  }

  &:focus {
    color: var(--color-pri);
  }

  &:active {
    color: var(--color-pri);
  }

  @media ${({ theme }) => theme.mediaQueries.mobile_landscape} {
    color: white;
    font-family: "Roboto";
    text-transform: uppercase;
    -webkit-letter-spacing: 0.1rem;
    -moz-letter-spacing: 0.1rem;
    -ms-letter-spacing: 0.1rem;
    -webkit-letter-spacing: 0.1rem;
    -moz-letter-spacing: 0.1rem;
    -ms-letter-spacing: 0.1rem;
    letter-spacing: 0.1rem;
    margin-right: 0rem;
    font-size: 0.65rem;
    font-weight: 400;
  }
`

export const ActionLink = styled(Link)`
  color: ${(props) => (props.black ? "var(--color-blk)" : "var(--color-wht)")};
  font-size: 0.8rem;
  font-family: "Roboto";
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 0.1rem;
  text-decoration: none;

  transition: all var(--speed);

  &:hover {
    color: var(--color-pri);
  }

  &:focus {
    color: var(--color-pri);
  }

  &:active {
    color: var(--color-pri);
  }
`

export const SayingText = styled.h2`
  color: white;
  font-family: graphik;
  font-size: 2rem;
  letter-spacing: 0.1rem;
  font-weight: 600;
  width: 65%;
`

export const CardNumberText = styled.p`
  color: white;
  font-size: 0.8rem;
  font-family: "Roboto";
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 0.1rem;
  width: 12%;
  margin: 0rem;
`

export const CardNumberTextBackground = styled.p`
  color: white;
  font-size: 0.8rem;
  font-family: "Roboto";
  text-transform: uppercase;
  font-weight: 600;
  -webkit-letter-spacing: 0.1rem;
  -moz-letter-spacing: 0.1rem;
  -ms-letter-spacing: 0.1rem;
  letter-spacing: 0.1rem;
  margin: 0rem;
  background: var(--color-pri);
  padding: 0.5rem;
  margin-left: -1.5rem;
`

export const CardHeaderText = styled.h2`
  color: white;
  font-family: graphik;
  font-size: 1.6rem;
  font-weight: 400;
  margin: 0rem;
`

export const CardHeaderText2 = styled.h2`
  color: white;
  font-family: graphik;
  font-size: 3.5rem;
  letter-spacing: 0.1rem;
  font-weight: 700;
`

export const CardSubText = styled.p`
  color: white;
  font-size: 0.8rem;
  font-family: "Roboto";
  text-transform: capitalize;
  font-weight: 400;
  letter-spacing: 0.1rem;
  padding: 0% 12%;
  margin: 0rem;
`
